import $ from "jquery";
import {$doc} from "./_globals.js";

let currentBtn = null;
const $modal = $(".js-submit-interception-modal");

function handle($evt, $btn) {
  $evt.preventDefault();
  $evt.stopImmediatePropagation();

  const btn = $btn.get(0);
  if (btn === currentBtn) return;

  $modal.modal("hide");

  const data = $btn.data("submit-intercept");
  const $form = $btn.closest("form");
  const $modalBtn = $btn.clone().attr("data-submit-intercept", null).addClass("js-submit-interception-submit");
  const template = new VOID.Template();
  template.addTemplate("base", $(data.body).html());
  $modal.find(".js-submit-interception-modal-title").text(data.title);
  $modal.find(".js-submit-interception-modal-body").html(template.parse("base", { text: htmlEntities(data.text || "") }));
  $modal.find(".js-submit-interception-modal-submit").replaceWith($modalBtn);
  const $modalForm = $modalBtn.closest("form");

  $modalForm.on("submit", $evt => {
    $evt.preventDefault();

    $modalForm.find("input").add($btn).each((i, el) => {
      // TODO: checkboxes, radios?
      const $prevEl = $form.find(`[type=hidden][name="${el.name}"]`);
      if ($prevEl.length) {
        $prevEl.val(el.value);
      } else {
        const $newEl = $(`<input type="hidden" name="${el.name}" value="${el.value}" />`);
        $newEl.insertBefore($btn);
      }
    });

    $form.trigger("submit", true);
  });

  $modal.modal("show");

  $modal.one("hidden.bs.modal", () => { currentBtn = null; });
}

$doc.on("click", "[data-submit-intercept]", function($evt, passthrough) {
  if (passthrough) return;
  handle($evt, $(this))
});

/*$doc.on("submit", function ($evt, passthrough) {
  if (passthrough) return;
  const $btn = $($evt.target).find("[data-submit-intercept]");
  if ($btn.length > 1) console.warn("Submission interceptor chose the first candidate button.");
  if ($btn.length) return handle($evt, $btn);
});*/
